(() => {
  const initCursor = () => {
    const cursor = document.getElementById('loomforma-site-cursor');
    if (!cursor || window.matchMedia('(pointer: coarse)').matches) return;

    const interactiveSelector =
      'a, button, label, summary, input, select, textarea, [role=\"button\"], .product-card, .loomforma-product-card, .loomforma-filter-link, .loomforma-interactive';

    document.addEventListener('mousemove', (event) => {
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
      cursor.style.opacity = '1';
    });

    document.addEventListener('mouseover', (event) => {
      if (event.target.closest(interactiveSelector)) {
        cursor.classList.add('is-active');
      }
    });

    document.addEventListener('mouseout', (event) => {
      if (!event.target.closest(interactiveSelector)) return;
      if (event.relatedTarget && event.relatedTarget.closest(interactiveSelector)) return;
      cursor.classList.remove('is-active');
    });

    document.addEventListener('mouseleave', () => {
      cursor.style.opacity = '0';
    });
  };

  const initLiveCartCount = () => {
    const countNodes = () => document.querySelectorAll('[data-loomforma-cart-count]');
    const linkNodes = () => document.querySelectorAll('[data-loomforma-cart-link]');

    const parseCount = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    let lastKnownCount = null;
    const initialNode = countNodes()[0];
    if (initialNode) {
      lastKnownCount = parseCount(initialNode.textContent.trim());
    }

    const animateCartBadge = () => {
      const nodes = [...linkNodes(), ...countNodes()];
      nodes.forEach((node) => {
        node.classList.remove('is-loomforma-cart-bump');
        void node.offsetWidth;
        node.classList.add('is-loomforma-cart-bump');
      });

      window.setTimeout(() => {
        nodes.forEach((node) => {
          node.classList.remove('is-loomforma-cart-bump');
        });
      }, 420);
    };

    const setCount = (count) => {
      if (!Number.isFinite(count)) return;
      countNodes().forEach((node) => {
        node.textContent = String(count);
      });
    };

    const readCount = (cartData) => {
      if (!cartData) return null;
      if (Number.isFinite(cartData.item_count)) return cartData.item_count;
      if (Array.isArray(cartData.items)) {
        return cartData.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      }
      return null;
    };

    const shouldAnimateAdd = (source, nextCount) => {
      if (!Number.isFinite(nextCount)) return false;
      if (!Number.isFinite(lastKnownCount)) return false;
      if (nextCount <= lastKnownCount) return false;
      return source === 'product-form' || source === 'quick-add' || source === 'quick-add-bulk';
    };

    const applyCount = (nextCount, source) => {
      if (!Number.isFinite(nextCount)) return;
      if (shouldAnimateAdd(source, nextCount)) {
        animateCartBadge();
      }
      setCount(nextCount);
      lastKnownCount = nextCount;
    };

    const refreshFromCartApi = (source) => {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(`${cartUrl}.js`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((data) => {
          const count = readCount(data);
          if (count !== null) applyCount(count, source);
        })
        .catch(() => {});
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const source = event && event.source;
        const count = readCount(event && event.cartData);
        if (count !== null) {
          applyCount(count, source);
        } else {
          refreshFromCartApi(source);
        }
      });
    }
  };

  initCursor();
  initLiveCartCount();
})();
